import { render } from "./BateriesSystem12V.vue?vue&type=template&id=f9cd80cc"
import script from "./BateriesSystem12V.vue?vue&type=script&lang=js"
export * from "./BateriesSystem12V.vue?vue&type=script&lang=js"

import "./BateriesSystem12V.vue?vue&type=style&index=0&id=f9cd80cc&lang=css"

import exportComponent from "/builds/elektro3-projects/elektro3-web/elektro3-komatools-web/elektro3-komatools-web-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__